var Backbone, RefinementContextLogger,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Backbone = require('backbone');

RefinementContextLogger = (function(superClass) {
  extend(RefinementContextLogger, superClass);

  function RefinementContextLogger() {
    return RefinementContextLogger.__super__.constructor.apply(this, arguments);
  }

  RefinementContextLogger.prototype._selectors = {
    ATTR_BHC: 'data-bhc',
    CARD_BADGE: '.cui-badge',
    CARD_BOUGHT_COUNT: '.cui-quantity-bought',
    CARD_DISTANCE: '.cui-location-distance',
    CARD_IN_STORE_PICKUP: '.cui-location',
    CARD_PRICE_ORIGINAL: '.cui-price-original',
    CARD_PRICE_DISCOUNT: '.cui-price-discount',
    CARD_RATING_CONTAINER: '.cui-review-rating .rating',
    CARD_RATING_COUNT: '.rating-count',
    CARD_RATING_FULL_STAR: '.full-star',
    CARD_RATING_HALF_STAR: '.half-star',
    CARD_TITLE: '.cui-udc-title',
    CARD_URGENCY_PRICING: '.cui-promotions'
  };

  RefinementContextLogger.prototype._DEFAULT_CATEGORY = 'goods';

  RefinementContextLogger.prototype._DEFAULT_SORT = 'relevance';

  RefinementContextLogger.prototype.initialize = function(arg) {
    var options;
    options = arg.options;
    return this._logDealAndCard = options._logDealAndCard, options;
  };

  RefinementContextLogger.prototype._addLoggerEvent = function(event) {
    return OptimizeSuite.TrackingHub.add('deal-card-click', this._getEventMeta(event));
  };

  RefinementContextLogger.prototype._getEventMeta = function(event) {
    var eventMeta;
    eventMeta = {
      category: this._getCategoryHierarchy(),
      pagination: {
        page: this._getCurrentPageNumber(),
        sort: this._getSort()
      },
      selectedRefinements: this._getRefinements()
    };
    if (this._logDealAndCard) {
      eventMeta.deal = this._getDealInfo();
      eventMeta.card = this._getCardInfo(event.currentTarget);
    }
    return eventMeta;
  };

  RefinementContextLogger.prototype._getDealInfo = function() {
    return {
      id: this._getDealId(),
      uuid: this._getDealUuid(),
      href: this._getDealHref(),
      categorization: this._getDealCategorization(),
      reviews: this._getDealReviewInfo()
    };
  };

  RefinementContextLogger.prototype._getCardInfo = function(target) {
    var inStorePickup;
    inStorePickup = this._getCardInStorePickup(target);
    return {
      title: this._getCardTitle(target),
      position: this._getCardPosition(target),
      value: this._getCardValue(target),
      price: this._getCardPrice(target),
      badge: this._getCardBadge(target),
      boughtCount: this._getCardBoughtCount(target),
      urgencyPricing: this._getCardUrgencyPricing(target),
      inStorePickup: inStorePickup,
      distance: inStorePickup ? this._getCardDistance(target) : void 0,
      reviews: this._getCardReviewInfo(target)
    };
  };

  RefinementContextLogger.prototype._getDealId = function() {
    return null;
  };

  RefinementContextLogger.prototype._getDealUuid = function() {
    return null;
  };

  RefinementContextLogger.prototype._getDealHref = function() {
    return null;
  };

  RefinementContextLogger.prototype._getDealCategorization = function() {
    return [];
  };

  RefinementContextLogger.prototype._getDealReviewInfo = function() {
    return {};
  };

  RefinementContextLogger.prototype._getCardTitle = function(target) {
    return $(target).find(this._selectors.CARD_TITLE).text().trim();
  };

  RefinementContextLogger.prototype._getCardPosition = function() {
    return null;
  };

  RefinementContextLogger.prototype._getCardValue = function(target) {
    return $(target).find(this._selectors.CARD_PRICE_ORIGINAL).first().text().trim();
  };

  RefinementContextLogger.prototype._getCardPrice = function(target) {
    return $(target).find(this._selectors.CARD_PRICE_DISCOUNT).first().text().trim();
  };

  RefinementContextLogger.prototype._getCardBadge = function(target) {
    return $(target).find(this._selectors.CARD_BADGE).first().text().trim() || null;
  };

  RefinementContextLogger.prototype._getCardBoughtCount = function(target) {
    return parseInt($(target).find(this._selectors.CARD_BOUGHT_COUNT).first().text().replace(/[^\d]/g, ''), 10) || null;
  };

  RefinementContextLogger.prototype._getCardUrgencyPricing = function(target) {
    return $(target).find(this._selectors.CARD_URGENCY_PRICING).first().text().trim() || null;
  };

  RefinementContextLogger.prototype._getCardInStorePickup = function(target) {
    return !!$(target).find(this._selectors.CARD_IN_STORE_PICKUP).length;
  };

  RefinementContextLogger.prototype._getCardDistance = function(target) {
    var rawDistance, ref;
    rawDistance = $(target).find(this._selectors.CARD_DISTANCE).first().text();
    if (!rawDistance) {
      return -1;
    }
    return parseInt((ref = rawDistance.match(/[\d,]+/)) != null ? ref[0] : void 0, 10);
  };

  RefinementContextLogger.prototype._getCardReviewInfo = function(target) {
    var ratingDisplay, ref;
    ratingDisplay = $(target).find(this._selectors.CARD_RATING_CONTAINER).first();
    return {
      ratingCount: parseInt((ref = $(target).find(this._selectors.CARD_RATING_COUNT).attr(this._selectors.ATTR_BHC)) != null ? ref.split(':')[1] : void 0, 10) || 0,
      averageRating: ratingDisplay.find(this._selectors.CARD_RATING_FULL_STAR).length + 0.5 * ratingDisplay.find(this._selectors.CARD_RATING_HALF_STAR).length
    };
  };

  RefinementContextLogger.prototype._getSort = function() {
    return this._DEFAULT_SORT;
  };

  RefinementContextLogger.prototype._getCategoryHierarchy = function() {
    return {
      category: this._DEFAULT_CATEGORY,
      id: this._DEFAULT_CATEGORY,
      level: 1
    };
  };

  RefinementContextLogger.prototype._getCurrentPageNumber = function() {
    return 1;
  };

  RefinementContextLogger.prototype._getRefinements = function() {
    return [];
  };

  return RefinementContextLogger;

})(Backbone.View);

module.exports = RefinementContextLogger;

//# sourceMappingURL=data:application/json;base64,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
